import { Component, OnInit, AfterViewInit, OnDestroy, ViewChildren, ElementRef } from '@angular/core';
import { GlobalDataOpsService, GlobalDomOpsService, AcepSSOService, CommonOperationsService } from '@acepteam/globalspack';
import { DomService, DataService, LoggerService, HelperService } from '../../../core/services';


import { Subscription, Observable, fromEvent } from 'rxjs';

import { FormBuilder, FormControlName, FormGroup } from '@angular/forms';
import { AccountType } from '../../../shared/enums/data.enums';





@Component({
  selector: 'app-common-base',
  template: ''
})
export class CommonBaseComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  AccountType: typeof AccountType = AccountType;

  protected subscriptions: Array<Subscription> = [];  
  protected errorMessage: string = "";
  
  constructor(
    public globalDataOpsService: GlobalDataOpsService, 
    public globalDomOpsService: GlobalDomOpsService,
    public commonOpsService: CommonOperationsService, 
    public ssoService: AcepSSOService, 
    public dataService: DataService, 
    public domService: DomService, 
    public helperService: HelperService,
    public loggerService: LoggerService,
    public fb: FormBuilder
  ) { 
    
  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    
    // Watch for the blur event from any input element on the form.
    // let controlBlurs: Observable<any>[] = this.formInputElements
    // .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    }); 
  }

  onError()
  {
    this.globalDomOpsService.notify("Internal Server Error", "", "error");
    this.loggerService.logError(this.errorMessage);
  }


}
